import { StoresState } from '../reducers/stores';
import { isDebugMode } from '../utils/local-storage';
import * as Redux from 'redux';
import { ExtensionsState } from '../reducers/extensions';
import { QueryStringState } from '../reducers/queryString';

export interface DirectoryStoreState {
  stores: StoresState;
  extensions: ExtensionsState;
  queryString: QueryStringState;
}

export type WindowExtended = Window & {
  store: any;
  persistor: any;
  isDebugMode: typeof isDebugMode;
  Raven?: any;
};

export interface Store {
  id: number;
  store: string;
  sloc: string;
  store_api_uuid: string;
  number: string;
}

export interface Extension {
  active: boolean;
  code: string;
  dial_plan_id: number;
  id: number;
  name: string;
  overridden_code: string;
}

export enum SortOrder {
  storesAsc = 'Stores A-Z',
  storesDesc = 'Stores Z-A',
  numberAsc = 'Store Number 0-9',
  numberDesc = 'Store Number 9-0',
}

export interface Action<T = any> {
  type: string;
  payload: T;
  meta?: { [key: string]: any };
}

export type Dispatch<T = Action> = Redux.Dispatch<T>;

export interface MappedDispatch {
  dispatch: Dispatch;
}
